// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .layout {
    display: flex;
    min-height: 100vh;
  }
  
  .main-content {
    flex-grow: 1;
    margin-left: 250px;
    min-height: 100vh;
    background-color: var(--light-grey);
    padding: 80px var(--spacing-md) var(--spacing-md);
    transition: margin-left 0.3s ease;
  }
  .layout.sidebar-collapsed .main-content {
    margin-left: 60px;
  }
  .content {
    max-width: 1200px;
    margin: 0 auto;
    padding: var(--spacing-md);
  }
  
  @media (max-width: 768px) {
    .main-content {
      margin-left: 0;
      padding-top: 60px;
    }
  }

  .main-content.sidebar-collapsed {
    margin-left: 60px;
  } */


  .layout {
    display: flex;
    min-height: 100vh;
  }
   
  .main-content {
    flex-grow: 1;
    margin-left: 250px;
    min-height: 100vh;
    background-color: var(--light-grey);
    padding: 80px var(--spacing-md) var(--spacing-md);
    transition: margin-left 0.3s ease;
  }
  .layout.sidebar-collapsed .main-content {
    margin-left: 60px;
  }
  .content {
    max-width: 1200px;
    margin: 0 auto;
    padding: var(--spacing-md);
  }
   
  @media (max-width: 768px) {
    .main-content {
      margin-left: 0;
      padding-top: 75px;
      width: 100% !important;
    }
   
    .main-content.sidebar-collapsed {
      margin-left: 0;
    }
    .sidebar-menu li a span {
      font-size: 12px !important;
    }
    .sidebar-menu li a i  {
      width: 0px !important;
    }
  }
   
  .main-content.sidebar-collapsed {
    margin-left: 60px;
  }`, "",{"version":3,"sources":["webpack://./src/styles/components/layout.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KA+BK;;;EAGH;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,mCAAmC;IACnC,iDAAiD;IACjD,iCAAiC;EACnC;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,0BAA0B;EAC5B;;EAEA;IACE;MACE,cAAc;MACd,iBAAiB;MACjB,sBAAsB;IACxB;;IAEA;MACE,cAAc;IAChB;IACA;MACE,0BAA0B;IAC5B;IACA;MACE,qBAAqB;IACvB;EACF;;EAEA;IACE,iBAAiB;EACnB","sourcesContent":["/* .layout {\r\n    display: flex;\r\n    min-height: 100vh;\r\n  }\r\n  \r\n  .main-content {\r\n    flex-grow: 1;\r\n    margin-left: 250px;\r\n    min-height: 100vh;\r\n    background-color: var(--light-grey);\r\n    padding: 80px var(--spacing-md) var(--spacing-md);\r\n    transition: margin-left 0.3s ease;\r\n  }\r\n  .layout.sidebar-collapsed .main-content {\r\n    margin-left: 60px;\r\n  }\r\n  .content {\r\n    max-width: 1200px;\r\n    margin: 0 auto;\r\n    padding: var(--spacing-md);\r\n  }\r\n  \r\n  @media (max-width: 768px) {\r\n    .main-content {\r\n      margin-left: 0;\r\n      padding-top: 60px;\r\n    }\r\n  }\r\n\r\n  .main-content.sidebar-collapsed {\r\n    margin-left: 60px;\r\n  } */\r\n\r\n\r\n  .layout {\r\n    display: flex;\r\n    min-height: 100vh;\r\n  }\r\n   \r\n  .main-content {\r\n    flex-grow: 1;\r\n    margin-left: 250px;\r\n    min-height: 100vh;\r\n    background-color: var(--light-grey);\r\n    padding: 80px var(--spacing-md) var(--spacing-md);\r\n    transition: margin-left 0.3s ease;\r\n  }\r\n  .layout.sidebar-collapsed .main-content {\r\n    margin-left: 60px;\r\n  }\r\n  .content {\r\n    max-width: 1200px;\r\n    margin: 0 auto;\r\n    padding: var(--spacing-md);\r\n  }\r\n   \r\n  @media (max-width: 768px) {\r\n    .main-content {\r\n      margin-left: 0;\r\n      padding-top: 75px;\r\n      width: 100% !important;\r\n    }\r\n   \r\n    .main-content.sidebar-collapsed {\r\n      margin-left: 0;\r\n    }\r\n    .sidebar-menu li a span {\r\n      font-size: 12px !important;\r\n    }\r\n    .sidebar-menu li a i  {\r\n      width: 0px !important;\r\n    }\r\n  }\r\n   \r\n  .main-content.sidebar-collapsed {\r\n    margin-left: 60px;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
